/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_S1_TitleInputs */

const en_guide_what_is_json_s1_title = /** @type {(inputs: Guide_What_Is_Json_S1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Understanding JSON Structure`)
};

const ko_guide_what_is_json_s1_title = /** @type {(inputs: Guide_What_Is_Json_S1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 구조 이해하기`)
};

const ja_guide_what_is_json_s1_title = /** @type {(inputs: Guide_What_Is_Json_S1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONの構造を理解する`)
};

/**
* | output |
* | --- |
* | "Understanding JSON Structure" |
*
* @param {Guide_What_Is_Json_S1_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_s1_title = /** @type {((inputs?: Guide_What_Is_Json_S1_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_S1_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_s1_title(inputs)
	if (locale === "ko") return ko_guide_what_is_json_s1_title(inputs)
	return ja_guide_what_is_json_s1_title(inputs)
});